export default function flattenValues(obj) {
    const flat = {};
    Object.keys(obj).forEach(function(key) {
        const val = obj[key];
        flat[key] = Array.isArray(val) && val.length === 1 ? val[0] : val;
    });

    return flat;
}



// WEBPACK FOOTER //
// ./src/lib/flattenValues.js